import React from 'react';
import FaIconView from '../FaIconView/FaIconView';
import { faCheck, faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './no_data_view.scss';

const NoDataView: React.FC = () => {
  return (
    <div className="wrapper">
      <FaIconView
        icon={faHeartBroken}
        iconSize="7x"
        iconStyle="grey-icon list-item-icon"
        label="لاتوجد حسابات حالياً، ولكن هناك مايمكنك تجربته:"
        labelStyle="grey-icon"
      />
      <div className="checklist-wrapper">
        <FaIconView
          icon={faCheck}
          label="مسح أي فلاتر قمت بإعدادها"
          iconStyle="grey-icon list-item-icon"
          labelStyle="grey-icon"
          containerStyle="flex-row list-item"
        />
        <FaIconView
          icon={faCheck}
          label="التغيير إلى منصة أخرى"
          iconStyle="grey-icon list-item-icon"
          labelStyle="grey-icon"
          containerStyle="flex-row list-item"
        />
        <Link to="/add-account">
          <FaIconView
            icon={faCheck}
            label="إضافة حساب جديد في هذه المنصة"
            iconStyle="grey-icon list-item-icon"
            labelStyle="grey-icon underlined"
            containerStyle="flex-row list-item"
          />
        </Link>
      </div>
    </div>
  );
};

export default NoDataView;
